// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"a2967ccd","553":"60733405","977":"504069e3"}[chunkId] + ".chunk.js";
};